/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Reloading_ProxyInputs */



/**
* | output |
* | --- |
* | "Reloading proxy... please wait a moment." |
*
* @param {Iconik_Proxy_Status_Reloading_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_reloading_proxy = /** @type {((inputs?: Iconik_Proxy_Status_Reloading_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Reloading_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechargement du proxy... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy wird neu geladen... bitte warten Sie einen Moment.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricaricamento del proxy... attendere un attimo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезагрузка прокси... пожалуйста, подождите немного.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recargando proxy... por favor espere un momento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载代理……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシを再読み込みしています...しばらくお待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी रीलोड हो रहा है... कृपया थोड़ी देर प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recarregando proxy... aguarde um momento.")
	return /** @type {LocalizedString} */ ("Reloading proxy... please wait a moment.")
});